import { LoginStore } from "@ts/look/service/LoginStore";
export var LoginStoreInstance = new LoginStore();
function restorePersistedLogin() {
    var _a;
    if (localStorage.getItem('auth') !== 'logged') {
        return;
    }
    LoginStoreInstance.setConnected(true);
    var user = null;
    try {
        user = JSON.parse((_a = localStorage.getItem('user')) !== null && _a !== void 0 ? _a : 'null');
    }
    catch (e) {
        user = null;
    }
    if (!user) {
        return;
    }
    LoginStoreInstance.setDetail({
        email: user.email,
        job_title: user.job_title,
        newsletter: user.newsletter,
    });
}
restorePersistedLogin();
document.addEventListener('login:true', function (event) {
    LoginStoreInstance.setConnected(true);
    LoginStoreInstance.setDetail(event.detail);
    document.dispatchEvent(new CustomEvent('look:login:true'));
});
